import { type CacheConfig, Network, type RequestParameters, type Variables } from 'relay-runtime';

import { getAggEndpoint, getRequestBody } from '@atlassian/relay-endpoint';
import { RelayExperimentalApis } from '@atlassian/relay-experimental-apis';
import { type ExternalDependencies, fetch as multiFetch } from '@atlassian/relay-fetch/multi-fetch';
import { createSubscribeFn, type SubscribeOptions } from '@atlassian/relay-subscription';

export const fetchFn = async (
	request: RequestParameters,
	variables: Variables,
	cacheConfig: CacheConfig,
) => {
	const endpoint = getAggEndpoint(request, cacheConfig);
	const body = getRequestBody(request, variables);

	return fetch(endpoint, {
		method: 'POST',
		credentials: 'same-origin',
		headers: {
			'content-type': 'application/json',
			'X-ExperimentalApi': RelayExperimentalApis.join(','),
		},
		body,
	}).then((response) => {
		return response.json();
	});
};

export const network = Network.create(fetchFn);

export type NetworkOptions = ExternalDependencies & SubscribeOptions;

export function createNetwork(networkOptions: NetworkOptions) {
	return Network.create(
		(request, variables, cacheConfig) =>
			multiFetch(request, variables, cacheConfig, networkOptions),
		networkOptions.isServer === false ? createSubscribeFn(networkOptions) : undefined,
	);
}
